import script from "./RecompareDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecompareDialog.vue?vue&type=script&setup=true&lang=ts"

import "./RecompareDialog.vue?vue&type=style&index=0&id=f5347e9e&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/data/workspace/PRD.standard_checktarget_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5347e9e"]])

export default __exports__